module.exports = __webpack_public_path__ + "media/assets/estimate_success_check-187da01ad5eb075974c4ff3a424424ac.svg";